export const categories = [
  {
    id: 'flooring',
    name: 'Flooring',
    icon: 'ri-layout-grid-line',
    description: 'Premium floor solutions for every space',
    items: ['Tiles', 'Bamboo', 'Fluted Panels (PVC/WPC)', 'CC Grass', 'OSB Board']
  },
  {
    id: 'sanitary',
    name: 'Sanitary & Bathroom',
    icon: 'ri-drop-line',
    description: 'Complete bathroom fixtures & fittings',
    items: ['Water Closet', 'Lavatory', 'Bathroom Cabinet', 'Shower Column', 'Bidet', 'Faucet']
  },
  {
    id: 'kitchen',
    name: 'Kitchen',
    icon: 'ri-restaurant-line',
    description: 'Quality kitchen essentials',
    items: ['Kitchen Sink', 'Faucet']
  },
  {
    id: 'structural',
    name: 'Structural',
    icon: 'ri-building-line',
    description: 'Durable structural materials',
    items: ['Nuts & Fasteners', 'Formwork & Shoring', 'Roofing', 'Framing & Furring', 'Boards & Decking', 'Scaffolding', 'Pipes & Tubes', 'Gabion & Accessories']
  },
  {
    id: 'interior',
    name: 'Interior Surface Finish',
    icon: 'ri-paint-brush-line',
    description: 'Modern interior surface solutions',
    items: ['PVC', 'WPC', 'UV Board', 'Flexstone', 'PU Stone']
  }
];

export const products = [
  // Flooring
  {
    id: 1,
    name: 'Ceramic Floor Tiles',
    category: 'flooring',
    subcategory: 'Tiles',
    price: 24.99,
    unit: 'per sqm',
    dimensions: '60cm x 60cm x 1cm',
    pricePerPiece: 6.25,
    pricePerUnit: 6.25,
    pricePerSqm: 24.99,
    description: 'High-quality ceramic floor tiles with a smooth, glossy finish. Ideal for living rooms, kitchens, and commercial spaces. Resistant to stains, moisture, and heavy foot traffic — easy to clean and maintain for long-lasting beauty.',
    image: 'https://public.readdy.ai/ai/img_res/fd5b40fcd12c934e8add5c0d5ea07bc5.jpg'
  },
  {
    id: 27,
    name: 'Pool Tiles Mosaic',
    category: 'flooring',
    subcategory: 'Tiles',
    price: 0,
    unit: 'per sqm',
    dimensions: '30cm x 30cm x 0.6cm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Vibrant glass mosaic tiles designed specifically for swimming pools and water features. The aqua and turquoise tones create a stunning underwater shimmer effect. Waterproof, slip-resistant, and built to withstand constant water exposure.',
    image: 'https://readdy.ai/api/search-image?query=swimming%20pool%20mosaic%20tiles%20vibrant%20aqua%20blue%20and%20turquoise%20glass%20tile%20sheets%20glistening%20wet%20surface%20underwater%20shimmer%20luxury%20pool%20interior%20close%20up%20product%20photography%20on%20clean%20white%20background%20premium%20quality%20ceramic%20mosaic&width=600&height=600&seq=pool-mosaic-tile-v2&orientation=squarish'
  },
  {
    id: 2,
    name: 'Natural Bamboo Flooring',
    category: 'flooring',
    subcategory: 'Bamboo',
    price: 39.99,
    unit: 'per sqm',
    dimensions: '96cm x 14cm x 1.5cm',
    pricePerPiece: 5.36,
    pricePerUnit: 5.36,
    pricePerSqm: 39.99,
    description: 'Eco-friendly natural bamboo flooring with a warm honey tone finish. Harder and more durable than most hardwoods, it offers excellent resistance to humidity and daily wear. A sustainable choice that adds warmth and elegance to any interior.',
    image: 'https://readdy.ai/api/search-image?query=natural%20bamboo%20flooring%20planks%20warm%20honey%20tone%20texture%20close%20up%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20premium%20building%20material&width=600&height=600&seq=floor-bamboo-001&orientation=squarish'
  },
  {
    id: 26,
    name: 'Fluted Panels (PVC/WPC)',
    category: 'flooring',
    subcategory: 'Fluted Panels (PVC/WPC)',
    price: 0,
    unit: 'per sqm',
    dimensions: '290cm x 12cm x 1cm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Modern fluted wall and ceiling panels made from durable PVC/WPC composite material. The ribbed texture adds depth and architectural character to any space. Lightweight, moisture-resistant, and simple to install — perfect for feature walls and accent areas.',
    image: 'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/032529fa18a9eb9d92b0502daa299efb.png'
  },
  {
    id: 4,
    name: 'CC Artificial Grass',
    category: 'flooring',
    subcategory: 'CC Grass',
    price: 19.99,
    unit: 'per sqm',
    dimensions: '200cm x 100cm x 3.5cm',
    pricePerPiece: 39.98,
    pricePerUnit: 39.98,
    pricePerSqm: 19.99,
    description: 'Premium CC artificial grass that looks and feels like real turf all year round. UV-stabilized fibers maintain their lush green color without watering or mowing. Ideal for gardens, balconies, playgrounds, and commercial landscaping.',
    image: 'https://readdy.ai/api/search-image?query=artificial%20grass%20turf%20CC%20grass%20lush%20green%20synthetic%20lawn%20close%20up%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20premium%20quality&width=600&height=600&seq=floor-grass-001&orientation=squarish'
  },
  {
    id: 25,
    name: 'OSB Board',
    category: 'flooring',
    subcategory: 'OSB Board',
    price: 0,
    unit: 'per sheet',
    dimensions: '244cm x 122cm x 1.1cm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Oriented Strand Board (OSB) engineered for structural strength and versatility. Made from compressed wood strands bonded with resin, it provides excellent load-bearing capacity. Widely used for subfloors, wall sheathing, and roof decking in construction.',
    image: 'https://readdy.ai/api/search-image?query=OSB%20oriented%20strand%20board%20structural%20panel%20wood%20chips%20compressed%20flat%20surface%20construction%20material%20close%20up%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20premium%20building%20material&width=600&height=600&seq=floor-osb-001&orientation=squarish'
  },
  // Sanitary & Bathroom
  {
    id: 28,
    name: 'Smart Toilet',
    category: 'sanitary',
    subcategory: 'Water Closet',
    price: 0,
    unit: 'per unit',
    dimensions: '72cm x 40cm x 52cm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Next-generation smart toilet with a sleek tankless design and integrated bidet functionality. Features auto open/close lid, heated seat, warm water cleansing, air dryer, and deodorizer. The minimalist form and matte finish make it a statement piece in any modern bathroom.',
    image: 'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/d3f692ca7cd54d04c16993b430da8189.png'
  },
  {
    id: 23,
    name: 'Square One-Piece Water Closet',
    category: 'sanitary',
    subcategory: 'Water Closet',
    price: 329.99,
    unit: 'per unit',
    dimensions: '70cm x 38cm x 78cm',
    pricePerPiece: 329.99,
    pricePerUnit: 329.99,
    pricePerSqm: null,
    description: 'Sleek square-design one-piece water closet with a seamless tank-to-bowl construction for easy cleaning. Features a powerful dual-flush system for water efficiency. The contemporary square silhouette complements modern and minimalist bathroom aesthetics.',
    image: 'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/12cb322493a1eb5a6c7680e223af38a5.png'
  },
  {
    id: 24,
    name: 'One-Piece Water Closet',
    category: 'sanitary',
    subcategory: 'Water Closet',
    price: 319.99,
    unit: 'per unit',
    dimensions: '68cm x 39cm x 76cm',
    pricePerPiece: 319.99,
    pricePerUnit: 319.99,
    pricePerSqm: null,
    description: 'Classic one-piece water closet with an integrated tank and bowl for a clean, streamlined look. Equipped with a quiet-close seat and dual-flush mechanism. Crafted from high-grade vitreous china for durability and a long-lasting white finish.',
    image: 'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/ca47b0f82567ce37b7782a7a0c9cfcc6.png'
  },
  {
    id: 29,
    name: 'Wall-hung Basin',
    category: 'sanitary',
    subcategory: 'Lavatory',
    price: 0,
    unit: 'per unit',
    dimensions: '555 x 445 x 520mm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Sleek wall-mounted wash basin with a semi-pedestal design that conceals plumbing for a clean, modern look. Crafted from high-grade vitreous china with a smooth glaze finish that resists stains and is easy to clean. Ideal for compact bathrooms and contemporary interiors.',
    image: 'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/6837ebc8b6f408b42d246f6cc12c8f91.png'
  },
  {
    id: 30,
    name: 'Wall-mounted Basin',
    category: 'sanitary',
    subcategory: 'Lavatory',
    price: 0,
    unit: 'per unit',
    dimensions: '450 x 380 x 170mm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Compact wall-mounted basin with a clean, rounded form and smooth vitreous china finish. Designed to save floor space while maintaining a stylish, modern aesthetic. Features a single tap hole and overflow, suitable for both residential and commercial bathrooms.',
    image: 'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/2323b5174c8e1a06eaa843e8f5d2a92b.png'
  },
  {
    id: 31,
    name: 'Wall-hung Bathroom Vanity',
    category: 'sanitary',
    subcategory: 'Bathroom Cabinet',
    price: 0,
    unit: 'per unit',
    dimensions: 'Mirror: 800 x 600mm | First Layer: 800 x 500 x 150mm | Second Layer: 800 x 500 x 80mm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Sophisticated wall-mounted bathroom vanity featuring a two-tier floating shelf design with an integrated LED backlit mirror. The first layer provides a deep countertop surface with an undermount basin, while the second layer offers additional storage space. Crafted from premium stone composite with a speckled dark granite finish, combining durability with contemporary elegance.',
    image: 'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/88eb53b60813bf168a831f06aea88fce.jpeg',
    images: [
      'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/88eb53b60813bf168a831f06aea88fce.jpeg',
      'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/19bbfdeca7991e26d8f28dc381293b2d.jpeg'
    ]
  },
  {
    id: 32,
    name: 'Wall-hung Bathroom Cabinet',
    category: 'sanitary',
    subcategory: 'Bathroom Cabinet',
    price: 0,
    unit: 'per unit',
    dimensions: 'Cabinet: 810 x 480 x 510mm | Mirror: 750 x 130 x 650mm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Sleek wall-hung bathroom cabinet in a matte dark grey finish, paired with an integrated mirror cabinet featuring open side shelving for toiletries. The floating design creates a clean, modern aesthetic while maximizing floor space. Includes a ceramic undermount basin with a smooth white finish. Ideal for contemporary bathrooms seeking both style and practical storage.',
    image: 'https://public.readdy.ai/ai/img_res/edited_27591c9e39bb1065c04d6395e0a791f1_1feb3955.jpg',
    images: [
      'https://public.readdy.ai/ai/img_res/edited_27591c9e39bb1065c04d6395e0a791f1_1feb3955.jpg',
      'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/8ab6a38681c7bc5997823be14d4e9095.jpeg'
    ]
  },
  {
    id: 33,
    name: 'Wall-hung Bathroom Cabinet 2',
    category: 'sanitary',
    subcategory: 'Bathroom Cabinet',
    price: 0,
    unit: 'per unit',
    dimensions: 'Cabinet: 600 x 470 x 480mm | Mirror: 550 x 130 x 630mm',
    material: 'Plywood',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Elegant wall-hung bathroom cabinet crafted from premium plywood, finished in a sophisticated matte dark grey tone. Paired with a mirrored cabinet featuring open side shelving for convenient toiletry storage. The compact floating design maximizes floor space while delivering a clean, contemporary aesthetic. Includes a ceramic undermount basin with a smooth white finish — perfect for modern bathrooms that demand both style and functionality.',
    image: 'https://public.readdy.ai/ai/img_res/edited_a2f77cb6fdcac962eb5d0da0ef4a7837_469f14de.jpg',
    images: [
      'https://public.readdy.ai/ai/img_res/edited_a2f77cb6fdcac962eb5d0da0ef4a7837_469f14de.jpg',
      'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/a90b0a4efd4803795b0d9e339925c2d5.jpeg',
      'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/02d581693250085f0ee6fcd303c6cda4.jpeg'
    ]
  },
  {
    id: 34,
    name: 'Wall-hung Bathroom Cabinet 3',
    category: 'sanitary',
    subcategory: 'Bathroom Cabinet',
    price: 0,
    unit: 'per unit',
    dimensions: 'Cabinet: 510 x 360 x 420mm | Mirror: 400 x 600mm',
    material: 'Plywood',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Compact wall-hung bathroom cabinet crafted from premium plywood with a warm natural wood slat finish. The ribbed cabinet front adds texture and warmth to any bathroom space, paired with a sleek rectangular mirror above. The floating design keeps the floor clear for a spacious, airy feel. Includes a ceramic undermount basin — a perfect blend of natural materials and modern minimalist design.',
    image: 'https://public.readdy.ai/ai/img_res/edited_fc5744d68f186fb5feb117e7e31b92ff_5e88577b.jpg',
    images: [
      'https://public.readdy.ai/ai/img_res/edited_fc5744d68f186fb5feb117e7e31b92ff_5e88577b.jpg',
      'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/800673ded8afe2d3691c054fa42e38a6.jpeg'
    ]
  },
  {
    id: 9,
    name: 'Shower Column 1',
    category: 'sanitary',
    subcategory: 'Shower Column',
    price: 349.99,
    unit: 'per unit',
    dimensions: '150cm x 30cm x 15cm',
    pricePerPiece: 349.99,
    pricePerUnit: 349.99,
    pricePerSqm: null,
    description: 'Available in two premium finishes — Gun Metal and Stainless Steel. The Gun Metal version showcases a bold matte black finish with a square overhead rain shower head, delivering a striking contemporary statement in any bathroom. The Stainless Steel version offers a polished brushed silver tone with the same square rain shower head design, providing a clean and timeless aesthetic. Both feature an adjustable hand shower, thermostatic bar valve, and are crafted from premium stainless steel with a durable coating that resists fingerprints, water spots, and corrosion.',
    image: 'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/92293c8f2c281b527c523b4ab7a57f28.png',
    images: [
      'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/92293c8f2c281b527c523b4ab7a57f28.png',
      'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/5d7f34903a7de0de5bbc7b592cb76229.png'
    ]
  },
  {
    id: 35,
    name: 'Shower Column 2',
    category: 'sanitary',
    subcategory: 'Shower Column',
    price: 0,
    unit: 'per unit',
    dimensions: '150cm x 30cm x 15cm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Available in two premium finishes — Gun Metal and Stainless Steel. The Gun Metal version features a bold, dark brushed finish that pairs beautifully with dark stone and tile surrounds for a dramatic bathroom aesthetic. The Stainless Steel version offers a classic brushed silver tone, delivering a clean and timeless look that complements any bathroom style. Both feature a round overhead rain shower head, adjustable hand shower with flexible hose, and exposed thermostatic bar valve. Crafted from premium stainless steel for lasting durability and corrosion resistance.',
    image: 'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/155bc6d6989065ea27651e99622549d4.png',
    images: [
      'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/155bc6d6989065ea27651e99622549d4.png',
      'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/821783e94ce2c26ef87e1e53e444d498.png'
    ]
  },
  {
    id: 36,
    name: 'Smart Shower Column',
    category: 'sanitary',
    subcategory: 'Shower Column',
    price: 0,
    unit: 'per unit',
    dimensions: '150cm x 30cm x 15cm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'A cutting-edge smart shower column featuring a sleek matte gun metal finish with an integrated LED thermostatic bar valve that displays water temperature through a vibrant color-changing light strip. The square overhead rain shower head delivers a wide, immersive rainfall experience, while the adjustable hand shower provides flexible targeted rinsing. Crafted from premium stainless steel with a durable dark coating that resists fingerprints, water spots, and corrosion — combining intelligent technology with bold contemporary design.',
    image: 'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/55eb969fb47e939e242ec8c77c63462f.png'
  },
  {
    id: 37,
    name: 'Bidet Sprayer — Stainless Steel Matte',
    category: 'sanitary',
    subcategory: 'Bidet',
    price: 0,
    unit: 'per unit',
    dimensions: '14cm x 5cm x 10cm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Handheld bidet sprayer in a premium stainless steel matte finish. The brushed satin surface gives it a refined, understated look that pairs beautifully with modern and minimalist bathroom designs. Ergonomic pistol-grip handle for comfortable one-handed use. Durable stainless steel construction resists corrosion and tarnishing for long-lasting performance.',
    image: 'https://public.readdy.ai/ai/img_res/edited_ef0887b01093f691a1f99d962a5ae6cd_8767b49b.jpg'
  },
  {
    id: 38,
    name: 'Bidet Sprayer — Gun Metal Matte',
    category: 'sanitary',
    subcategory: 'Bidet',
    price: 0,
    unit: 'per unit',
    dimensions: '14cm x 5cm x 10cm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Handheld bidet sprayer in a bold matte gun metal finish. The dark, smoky tone adds a dramatic and contemporary edge to any bathroom setting. Ergonomic pistol-grip handle ensures a secure, comfortable grip. Crafted from high-quality stainless steel with a durable dark coating that resists fingerprints, water spots, and corrosion.',
    image: 'https://public.readdy.ai/ai/img_res/edited_9c9802a4fe25a4a2d27e314420626ecf_1e041449.jpg'
  },
  {
    id: 39,
    name: 'Bidet Sprayer — Chrome',
    category: 'sanitary',
    subcategory: 'Bidet',
    price: 0,
    unit: 'per unit',
    dimensions: '14cm x 5cm x 10cm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Handheld bidet sprayer in a high-shine stainless steel glossy finish. The mirror-like polished surface delivers a sleek, luxurious look that complements chrome and polished bathroom fixtures. Ergonomic pistol-grip handle for easy one-handed operation. Premium stainless steel build ensures exceptional durability and resistance to rust and staining.',
    image: 'https://public.readdy.ai/ai/img_res/edited_a1171a26647a034823c9d87433031a00_0a5ed5c7.jpg'
  },
  {
    id: 41,
    name: 'Short Basin Faucet — Brush Steel',
    category: 'sanitary',
    subcategory: 'Faucet',
    price: 0,
    unit: 'per unit',
    dimensions: '18cm x 6cm x 24cm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Single-lever basin faucet in a bold matte gun metal finish. The dark, smoky tone adds a dramatic and contemporary edge to any bathroom setting, pairing beautifully with dark stone countertops and slate surrounds. Features a smooth ceramic disc cartridge for precise temperature and flow control with drip-free performance. The square-profile spout and angular lever handle deliver a strong architectural statement. Crafted from solid stainless steel with a durable dark coating that resists fingerprints, water spots, and corrosion.',
    image: 'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/0ffd0f58c399c015fd5a7cbb9eb3ab7b.png'
  },
  {
    id: 42,
    name: 'Tall Basin Faucet — Chrome',
    category: 'sanitary',
    subcategory: 'Faucet',
    price: 0,
    unit: 'per unit',
    dimensions: '8cm x 8cm x 30cm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Tall single-lever basin faucet in a high-shine polished chrome finish. The elongated cylindrical body and angular lever handle create a bold architectural statement, ideal for vessel basins and countertop bowls. Features a smooth ceramic disc cartridge for precise temperature and flow control with drip-free performance. The mirror-like chrome surface complements both classic and contemporary bathroom designs. Crafted from solid brass with a durable chrome plating that resists tarnishing, water spots, and corrosion.',
    image: 'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/224cf3a54594b5a02d4ebb514b58de44.png'
  },
  {
    id: 43,
    name: 'Tall Basin Faucet — Brush Steel',
    category: 'sanitary',
    subcategory: 'Faucet',
    price: 0,
    unit: 'per unit',
    dimensions: '8cm x 8cm x 28cm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Tall single-lever basin faucet in a premium brushed stainless steel matte finish. The cylindrical body and angular T-bar lever handle deliver a refined, architectural look that pairs beautifully with stone countertops and dark slate surrounds. Features a smooth ceramic disc cartridge for precise temperature and flow control with drip-free performance. Crafted from solid stainless steel with a durable brushed coating that resists fingerprints, water spots, and corrosion — ideal for vessel basins and countertop bowls in contemporary bathrooms.',
    image: 'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/546bc1548eab87052a1208b717dc385e.png'
  },
  {
    id: 44,
    name: 'Short Basin Faucet — Glossy',
    category: 'sanitary',
    subcategory: 'Faucet',
    price: 0,
    unit: 'per unit',
    dimensions: '15cm x 6cm x 20cm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Single-lever basin faucet in a stunning high-shine polished chrome finish. The compact short-body design features a square-profile spout and angular lever handle, delivering a sleek and modern aesthetic that pairs beautifully with round undermount basins and dark stone countertops. Features a smooth ceramic disc cartridge for precise temperature and flow control with drip-free performance. Crafted from solid brass with a durable chrome plating that resists tarnishing, water spots, and corrosion — a timeless choice for contemporary and minimalist bathrooms.',
    image: 'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/c9e1516dfee28562b39cca266aba47b0.png'
  },
  {
    id: 45,
    name: 'Basin Faucet — Chrome Classic',
    category: 'sanitary',
    subcategory: 'Faucet',
    price: 0,
    unit: 'per unit',
    dimensions: '16cm x 7cm x 22cm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Single-lever basin faucet in a premium high-shine polished chrome finish. The elegant curved spout and ergonomic lever handle deliver a refined, timeless aesthetic that complements both classic and contemporary bathroom designs. Features a smooth ceramic disc cartridge for precise temperature and flow control with drip-free performance. The flared base and graceful arc spout create a sophisticated silhouette, ideal for undermount basins and stone countertops. Crafted from solid brass with a durable chrome plating that resists tarnishing, water spots, and corrosion.',
    image: 'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/fae83782deb07dabd8438dadc2bae14a.png'
  },
  {
    id: 46,
    name: 'Long Basin Faucet — Brush Steel Round',
    category: 'sanitary',
    subcategory: 'Faucet',
    price: 0,
    unit: 'per unit',
    dimensions: '8cm x 8cm x 26cm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Tall single-lever basin faucet in a premium brushed stainless steel matte finish. The sleek cylindrical body and minimalist lever handle deliver a refined, contemporary aesthetic that pairs beautifully with dark stone countertops and vessel basins. Features a smooth ceramic disc cartridge for precise temperature and flow control with drip-free performance. Crafted from solid stainless steel with a durable brushed coating that resists fingerprints, water spots, and corrosion — a perfect choice for modern and minimalist bathroom designs.',
    image: 'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/7e2fcdd219850aa49b24ffcaf6763be4.png'
  },
  {
    id: 47,
    name: 'Short Basin Faucet — Brush Steel',
    category: 'sanitary',
    subcategory: 'Faucet',
    price: 0,
    unit: 'per unit',
    dimensions: '15cm x 8cm x 22cm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Single-lever basin faucet in a premium brushed stainless steel matte finish. The compact short-body design features a sleek cylindrical spout and minimalist lever handle, delivering a refined contemporary aesthetic that pairs beautifully with dark stone countertops and round undermount basins. Features a smooth ceramic disc cartridge for precise temperature and flow control with drip-free performance. Crafted from solid stainless steel with a durable brushed coating that resists fingerprints, water spots, and corrosion — a perfect choice for modern and minimalist bathroom designs.',
    image: 'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/e7329f637caf2a48cb29dd656bc06e3a.png'
  },
  // Kitchen
  {
    id: 53,
    name: 'Double Bowl Kitchen Sink — Gun Metal',
    category: 'kitchen',
    subcategory: 'Kitchen Sink',
    price: 0,
    unit: 'per unit',
    dimensions: '80cm x 45cm x 22cm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Premium double bowl undermount kitchen sink in a bold matte gun metal finish. Crafted from 304-grade stainless steel with a durable dark PVD coating that resists scratches, fingerprints, and corrosion. The deep dual basins provide ample space for washing large pots and pans. Pairs beautifully with dark kitchen countertops and gun metal faucets for a cohesive, contemporary kitchen aesthetic.',
    image: 'https://public.readdy.ai/ai/img_res/edited_7f79833f63d79081d473a60a118e902f_a8fdc3e2.jpg',
    images: [
      'https://public.readdy.ai/ai/img_res/edited_7f79833f63d79081d473a60a118e902f_a8fdc3e2.jpg',
      'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/1831e4902e762ae0dbf604032495a175.png'
    ]
  },
  {
    id: 54,
    name: 'Smart Workstation Kitchen Sink',
    category: 'kitchen',
    subcategory: 'Kitchen Sink',
    price: 0,
    unit: 'per unit',
    dimensions: '82cm x 46cm x 22cm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Premium smart workstation kitchen sink in a brushed stainless steel finish, featuring a multi-functional topmount design with an integrated pull-out faucet, built-in cutting board slot, and accessory rail. The deep main basin and compact side basin offer versatile workspace for food prep and washing. Crafted from 304-grade stainless steel for superior durability and corrosion resistance — a sleek, all-in-one centerpiece for modern kitchen islands and countertops.',
    image: 'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/b2d6b6e6dcc302d2452b495c3a38bb70.png',
    images: [
      'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/b2d6b6e6dcc302d2452b495c3a38bb70.png',
      'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/b2d6b6e6dcc302d2452b495c3a38bb70.png'
    ]
  },
  {
    id: 55,
    name: 'Double Bowl Topmount Kitchen Sink — Stainless Steel',
    category: 'kitchen',
    subcategory: 'Kitchen Sink',
    price: 0,
    unit: 'per unit',
    dimensions: '80cm x 45cm x 22cm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Sleek double bowl topmount kitchen sink in a premium brushed stainless steel finish. Crafted from 304-grade stainless steel for superior rust and stain resistance. The dual basins provide ample space for washing and food prep, while the integrated faucet deck and soap dispenser hole add convenience. Sound-dampening pads reduce noise — a refined and functional centerpiece for modern kitchen islands and countertops.',
    image: 'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/28c409a26542c7bedf54ae0ced80779a.png',
    images: [
      'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/28c409a26542c7bedf54ae0ced80779a.png',
      'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/eafe42669633ce9019a3dd38ca5764d5.jpeg'
    ]
  },
  {
    id: 48,
    name: '3-in-1 Kitchen Faucet — Gun Metal',
    category: 'kitchen',
    subcategory: 'Faucet',
    price: 0,
    unit: 'per unit',
    dimensions: '22cm x 8cm x 42cm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Premium 3-in-1 kitchen faucet in a bold matte gun metal finish, combining a high-arc flexible pull-out spray hose with a dedicated filtered water spout. Features dual lever controls for hot/cold and filtered water, delivering convenience and style in one sleek unit. The dark brushed coating resists fingerprints, water spots, and corrosion — a striking statement piece for modern and industrial kitchen designs.',
    image: 'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/c1cd49e6096770eee4afb75c13aed7a6.png'
  },
  {
    id: 49,
    name: 'Pull-Down Kitchen Faucet — Chrome',
    category: 'kitchen',
    subcategory: 'Faucet',
    price: 0,
    unit: 'per unit',
    dimensions: '20cm x 8cm x 44cm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Elegant high-arc pull-down kitchen faucet in a polished chrome finish. Features a smooth gooseneck spout with a retractable spray head offering stream and spray modes. The integrated sponge caddy basket keeps your sink area tidy. Single-lever control for effortless temperature and flow adjustment. Crafted from solid brass with a durable chrome plating that resists tarnishing, water spots, and corrosion — a timeless and functional centerpiece for any modern kitchen.',
    image: 'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/5d5f1dd5411e7d0207a352a5ba1405e6.png'
  },
  {
    id: 50,
    name: 'Pull-Down Kitchen Faucet — Brush Steel',
    category: 'kitchen',
    subcategory: 'Faucet',
    price: 0,
    unit: 'per unit',
    dimensions: '22cm x 8cm x 46cm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Sleek high-arc pull-down kitchen faucet in a premium brushed stainless steel finish. Features a smooth gooseneck spout with a retractable spray head offering stream and spray modes for versatile kitchen tasks. Single-lever control for effortless temperature and flow adjustment. Crafted from solid stainless steel with a durable brushed coating that resists fingerprints, water spots, and corrosion — a refined and functional centerpiece for modern and contemporary kitchen designs.',
    image: 'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/c1eec1f10ca3f9b29a123b3140303d72.png'
  },
  {
    id: 51,
    name: 'Pull-Down Kitchen Faucet — Chrome Classic',
    category: 'kitchen',
    subcategory: 'Faucet',
    price: 0,
    unit: 'per unit',
    dimensions: '20cm x 8cm x 42cm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Classic high-arc pull-down kitchen faucet in a polished chrome finish. Features a graceful gooseneck spout with a retractable spray head and side lever handle for precise temperature and flow control. The timeless chrome finish pairs beautifully with dark stone countertops and undermount sinks. Crafted from solid brass with durable chrome plating that resists tarnishing, water spots, and corrosion — a versatile and elegant choice for both modern and traditional kitchen designs.',
    image: 'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/c237b2b3ace96404b44f869e28c08b8f.png'
  },
  {
    id: 52,
    name: 'High-Arc Kitchen Faucet — Brush Steel',
    category: 'kitchen',
    subcategory: 'Faucet',
    price: 0,
    unit: 'per unit',
    dimensions: '20cm x 8cm x 44cm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Elegant high-arc kitchen faucet in a premium brushed stainless steel finish. The graceful gooseneck spout and dual-lever handle design deliver precise independent control of hot and cold water. The minimalist cylindrical form pairs beautifully with dark stone countertops and undermount sinks. Crafted from solid stainless steel with a durable brushed coating that resists fingerprints, water spots, and corrosion — a refined and timeless centerpiece for modern and contemporary kitchen designs.',
    image: 'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/bccda645ee4140d13e8a943001ddcc0e.png'
  },
  // Structural
  {
    id: 14,
    name: 'HDPE Water Pipes',
    category: 'structural',
    subcategory: 'Pipes & Tubes',
    price: 12.99,
    unit: 'per meter',
    dimensions: '100cm x 5cm (diameter)',
    pricePerPiece: 12.99,
    pricePerUnit: 12.99,
    pricePerSqm: null,
    description: 'High-density polyethylene (HDPE) pipes engineered for water supply, drainage, and underground installations. Flexible yet strong, they resist corrosion, chemicals, and UV degradation. Suitable for both residential and industrial plumbing systems.',
    image: 'https://readdy.ai/api/search-image?query=HDPE%20high%20density%20polyethylene%20pipes%20black%20industrial%20plumbing%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20premium%20construction%20material&width=600&height=600&seq=str-hdpe-001&orientation=squarish'
  },
  {
    id: 15,
    name: 'Corrugated Metal Roofing',
    category: 'structural',
    subcategory: 'Roofing',
    price: 18.99,
    unit: 'per sqm',
    dimensions: '244cm x 91cm x 0.4mm',
    pricePerPiece: 42.15,
    pricePerUnit: 42.15,
    pricePerSqm: 18.99,
    description: 'Galvanized corrugated metal roofing sheets offering superior weather protection and structural strength. The ribbed profile enhances rigidity and allows efficient rainwater runoff. Lightweight and easy to install, ideal for residential, agricultural, and industrial roofing.',
    image: 'https://readdy.ai/api/search-image?query=corrugated%20metal%20roofing%20sheet%20galvanized%20steel%20silver%20industrial%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20premium%20construction%20material&width=600&height=600&seq=str-roof-001&orientation=squarish'
  },
  {
    id: 16,
    name: 'Steel Furring Channel',
    category: 'structural',
    subcategory: 'Framing & Furring',
    price: 8.99,
    unit: 'per piece',
    dimensions: '305cm x 2.5cm x 2.5cm',
    pricePerPiece: 8.99,
    pricePerUnit: 8.99,
    pricePerSqm: null,
    description: 'Galvanized steel furring channels used as the primary framing system for drywall and ceiling installations. Lightweight yet rigid, they provide a flat, level surface for attaching boards and panels. Corrosion-resistant coating ensures long-term structural integrity.',
    image: 'https://readdy.ai/api/search-image?query=steel%20furring%20channel%20metal%20framing%20construction%20material%20galvanized%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20premium%20building%20material&width=600&height=600&seq=str-fur-001&orientation=squarish'
  },
  {
    id: 17,
    name: 'Fiber Cement Board',
    category: 'structural',
    subcategory: 'Boards & Decking',
    price: 22.99,
    unit: 'per sheet',
    dimensions: '244cm x 122cm x 0.6cm',
    pricePerPiece: 22.99,
    pricePerUnit: 22.99,
    pricePerSqm: 7.73,
    description: 'Durable fiber cement board suitable for interior and exterior wall cladding, ceilings, and partitions. Fire-resistant, moisture-proof, and termite-resistant, it outperforms traditional plywood and gypsum boards. Smooth surface accepts paint, tiles, and other finishes easily.',
    image: 'https://readdy.ai/api/search-image?query=fiber%20cement%20board%20flat%20smooth%20surface%20construction%20material%20grey%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20premium%20building%20material&width=600&height=600&seq=str-board-001&orientation=squarish'
  },
  // Structural — Nuts & Fasteners
  {
    id: 100,
    name: 'Flange Nut 12mm–17mm',
    category: 'structural',
    subcategory: 'Nuts & Fasteners',
    price: 0,
    unit: 'per piece',
    dimensions: '12mm–17mm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Heavy-duty galvanized flange nut with a built-in serrated washer flange that distributes load and prevents loosening under vibration. Available in 12mm to 17mm sizes. Ideal for structural steel connections, scaffolding, and formwork assemblies requiring secure, reliable fastening.',
    image: 'https://public.readdy.ai/ai/img_res/edited_9c3343d919d1381154c2170767453737_edb934b4.jpg'
  },
  {
    id: 101,
    name: 'Wing Nut 12mm–17mm',
    category: 'structural',
    subcategory: 'Nuts & Fasteners',
    price: 0,
    unit: 'per piece',
    dimensions: '12mm–17mm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Galvanized wing nut designed for quick hand-tightening and easy removal without tools. Available in 12mm to 17mm sizes. Widely used in formwork, scaffolding, and temporary structural connections where frequent assembly and disassembly is required.',
    image: 'https://public.readdy.ai/ai/img_res/edited_2bad65d067251e5517bb29558e8a7d52_cdbc4582.jpg'
  },
  // Structural — Formwork & Shoring
  {
    id: 102,
    name: 'Adjustable U-Head',
    category: 'structural',
    subcategory: 'Formwork & Shoring',
    price: 0,
    unit: 'per piece',
    dimensions: 'Standard',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Heavy-duty adjustable U-head jack used at the top of shoring posts to support beams and stringers in concrete formwork systems. The U-shaped fork cradles timber or steel beams securely. Height-adjustable for precise leveling on uneven surfaces.',
    image: 'https://readdy.ai/api/search-image?query=adjustable%20U-head%20shoring%20jack%20steel%20construction%20formwork%20support%20close%20up%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20industrial%20building%20material&width=600&height=600&seq=str-uhead-001&orientation=squarish'
  },
  {
    id: 103,
    name: 'Steel Tie Rod',
    category: 'structural',
    subcategory: 'Formwork & Shoring',
    price: 0,
    unit: 'per piece',
    dimensions: 'Standard',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'High-tensile steel tie rod used to hold opposing formwork panels together during concrete pouring. Prevents wall forms from spreading under concrete pressure. Compatible with standard wing nuts and flange nuts for quick assembly and disassembly.',
    image: 'https://readdy.ai/api/search-image?query=steel%20tie%20rod%20formwork%20construction%20hardware%20threaded%20rod%20close%20up%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20industrial%20building%20material&width=600&height=600&seq=str-tierod-001&orientation=squarish'
  },
  {
    id: 104,
    name: 'Adjustable Base Jack',
    category: 'structural',
    subcategory: 'Formwork & Shoring',
    price: 0,
    unit: 'per piece',
    dimensions: 'Standard',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Heavy-duty adjustable base jack used at the bottom of shoring frames and scaffolding posts to provide a stable, level foundation on uneven ground. The threaded screw mechanism allows precise height adjustment. Built from high-strength steel for maximum load-bearing capacity.',
    image: 'https://readdy.ai/api/search-image?query=adjustable%20base%20jack%20scaffolding%20shoring%20steel%20screw%20jack%20construction%20close%20up%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20industrial%20building%20material&width=600&height=600&seq=str-basejack-001&orientation=squarish'
  },
  {
    id: 105,
    name: 'Adjustable Shoring Jack',
    category: 'structural',
    subcategory: 'Formwork & Shoring',
    price: 0,
    unit: 'per piece',
    dimensions: 'Standard',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Telescoping adjustable shoring jack (prop) used to support concrete slabs, beams, and formwork during construction. The threaded inner tube allows precise height adjustment and fine-tuning of load distribution. Manufactured from heavy-gauge steel for high load capacity and long service life.',
    image: 'https://readdy.ai/api/search-image?query=adjustable%20shoring%20jack%20steel%20prop%20telescoping%20construction%20support%20close%20up%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20industrial%20building%20material&width=600&height=600&seq=str-shoringjack-001&orientation=squarish'
  },
  {
    id: 106,
    name: 'H-Frame Set (S20/S40)',
    category: 'structural',
    subcategory: 'Formwork & Shoring',
    price: 0,
    unit: 'per set',
    dimensions: 'S20 / S40',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Heavy-duty H-frame scaffolding set available in S20 and S40 configurations. The welded H-frame design provides exceptional stability and load-bearing capacity for multi-level shoring and scaffolding systems. Hot-dip galvanized finish ensures long-term corrosion resistance on construction sites.',
    image: 'https://readdy.ai/api/search-image?query=H-frame%20scaffolding%20set%20steel%20construction%20shoring%20frame%20galvanized%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20industrial%20building%20material&width=600&height=600&seq=str-hframe-001&orientation=squarish'
  },
  {
    id: 107,
    name: 'H-Frame Cross Brace',
    category: 'structural',
    subcategory: 'Formwork & Shoring',
    price: 0,
    unit: 'per piece',
    dimensions: 'Standard',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Diagonal cross brace for H-frame scaffolding systems, providing lateral stability and rigidity to the overall structure. Manufactured from high-strength steel with a galvanized finish. Quick-connect hooks allow fast and secure attachment to H-frame uprights without tools.',
    image: 'https://readdy.ai/api/search-image?query=H-frame%20cross%20brace%20scaffolding%20steel%20diagonal%20brace%20construction%20close%20up%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20industrial%20building%20material&width=600&height=600&seq=str-crossbrace-001&orientation=squarish'
  },
  {
    id: 108,
    name: 'Swivel/Fixed Cap',
    category: 'structural',
    subcategory: 'Formwork & Shoring',
    price: 0,
    unit: 'per piece',
    dimensions: 'Standard',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Heavy-duty swivel and fixed scaffold couplers/caps used to connect scaffolding tubes at various angles. The swivel type allows rotation for angled connections, while the fixed type locks tubes at 90°. Both are forged from high-strength steel with a galvanized finish for durability and corrosion resistance.',
    image: 'https://readdy.ai/api/search-image?query=swivel%20fixed%20scaffold%20coupler%20cap%20steel%20construction%20hardware%20close%20up%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20industrial%20building%20material&width=600&height=600&seq=str-swivelcap-001&orientation=squarish'
  },
  // Structural — Roofing
  {
    id: 109,
    name: 'Stone Coated Roof — Wood Design',
    category: 'structural',
    subcategory: 'Roofing',
    price: 0,
    unit: 'per sqm',
    dimensions: 'Standard sheet',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Premium stone-coated steel roofing tile in a classic wood shake design. The natural stone chip surface coating provides exceptional weather resistance, UV protection, and noise reduction. Combines the authentic look of cedar wood shakes with the strength and longevity of galvanized steel — ideal for residential and commercial roofing.',
    image: 'https://readdy.ai/api/search-image?query=stone%20coated%20steel%20roof%20tile%20wood%20shake%20design%20brown%20texture%20close%20up%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20premium%20roofing%20material&width=600&height=600&seq=str-roofwood-001&orientation=squarish'
  },
  {
    id: 110,
    name: 'Stone Coated Roof — Shingles',
    category: 'structural',
    subcategory: 'Roofing',
    price: 0,
    unit: 'per sqm',
    dimensions: 'Standard sheet',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Premium stone-coated steel roofing tile in a traditional shingle profile. The natural stone chip surface delivers superior weather resistance, UV protection, and sound dampening. Replicates the classic look of asphalt shingles with the superior durability and longevity of galvanized steel — perfect for residential roofing projects.',
    image: 'https://readdy.ai/api/search-image?query=stone%20coated%20steel%20roof%20shingles%20profile%20dark%20charcoal%20texture%20close%20up%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20premium%20roofing%20material&width=600&height=600&seq=str-roofshingle-001&orientation=squarish'
  },
  {
    id: 111,
    name: 'Long Span Rib Roof',
    category: 'structural',
    subcategory: 'Roofing',
    price: 0,
    unit: 'per sqm',
    dimensions: 'Standard sheet',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Long-span ribbed metal roofing sheet designed for wide-span structures such as warehouses, factories, and commercial buildings. The deep rib profile provides exceptional structural rigidity and efficient rainwater drainage. Available in galvanized and color-coated finishes for both functional and aesthetic applications.',
    image: 'https://readdy.ai/api/search-image?query=long%20span%20rib%20roof%20metal%20sheet%20galvanized%20corrugated%20industrial%20roofing%20close%20up%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20premium%20construction%20material&width=600&height=600&seq=str-riboof-001&orientation=squarish'
  },
  // Structural — Framing & Furring
  {
    id: 112,
    name: 'Metal Furring',
    category: 'structural',
    subcategory: 'Framing & Furring',
    price: 0,
    unit: 'per piece',
    dimensions: 'Standard length',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Galvanized metal furring strips used as secondary framing members for ceiling and wall systems. Lightweight and easy to cut, they provide a flat, level substrate for attaching gypsum boards, fiber cement boards, and other panel materials. Corrosion-resistant coating ensures long-term performance.',
    image: 'https://readdy.ai/api/search-image?query=metal%20furring%20strip%20galvanized%20steel%20framing%20channel%20construction%20ceiling%20wall%20close%20up%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20building%20material&width=600&height=600&seq=str-metalfur-001&orientation=squarish'
  },
  {
    id: 113,
    name: 'Stud',
    category: 'structural',
    subcategory: 'Framing & Furring',
    price: 0,
    unit: 'per piece',
    dimensions: 'Standard length',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Galvanized steel stud used as the primary vertical framing member in light-gauge steel wall partition systems. The C-shaped profile provides excellent strength-to-weight ratio and is compatible with standard track and furring systems. Ideal for interior partition walls, drywall framing, and suspended ceiling grids.',
    image: 'https://readdy.ai/api/search-image?query=steel%20stud%20galvanized%20light%20gauge%20framing%20partition%20wall%20construction%20close%20up%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20building%20material&width=600&height=600&seq=str-stud-001&orientation=squarish'
  },
  {
    id: 114,
    name: 'C-Purlins (G.I.)',
    category: 'structural',
    subcategory: 'Framing & Furring',
    price: 0,
    unit: 'per piece',
    dimensions: 'Standard length',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Galvanized iron (G.I.) C-purlins used as horizontal structural members to support roofing sheets and wall cladding. The C-channel profile provides excellent bending strength and is easy to connect to primary steel frames. Hot-dip galvanized finish ensures superior corrosion resistance for long-term outdoor use.',
    image: 'https://readdy.ai/api/search-image?query=C%20purlin%20galvanized%20steel%20channel%20structural%20framing%20roofing%20support%20close%20up%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20construction%20material&width=600&height=600&seq=str-cpurlin-001&orientation=squarish'
  },
  {
    id: 115,
    name: 'Tubular (G.I. & B.I.)',
    category: 'structural',
    subcategory: 'Pipes & Tubes',
    price: 0,
    unit: 'per piece',
    dimensions: 'Standard length',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Square and rectangular hollow section tubular steel available in Galvanized Iron (G.I.) and Black Iron (B.I.) finishes. Used for structural framing, gates, fences, furniture frames, and general fabrication. G.I. tubes offer corrosion resistance for outdoor use, while B.I. tubes are ideal for welded structures and painted applications.',
    image: 'https://readdy.ai/api/search-image?query=square%20hollow%20section%20tubular%20steel%20galvanized%20black%20iron%20structural%20framing%20close%20up%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20construction%20material&width=600&height=600&seq=str-tubular-001&orientation=squarish'
  },
  {
    id: 116,
    name: 'G.I. Pipe S20/S40',
    category: 'structural',
    subcategory: 'Pipes & Tubes',
    price: 0,
    unit: 'per piece',
    dimensions: 'S20 / S40',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Galvanized iron (G.I.) pipes available in Schedule 20 (S20) and Schedule 40 (S40) wall thicknesses. Used for water supply lines, structural columns, handrails, and general construction applications. The hot-dip galvanized coating provides excellent corrosion resistance for both indoor and outdoor installations.',
    image: 'https://readdy.ai/api/search-image?query=galvanized%20iron%20pipe%20GI%20pipe%20schedule%2040%20steel%20construction%20plumbing%20close%20up%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20building%20material&width=600&height=600&seq=str-gipipe-001&orientation=squarish'
  },
  // Structural — Boards & Decking
  {
    id: 117,
    name: 'Phenolic Board',
    category: 'structural',
    subcategory: 'Boards & Decking',
    price: 0,
    unit: 'per sheet',
    dimensions: '244cm x 122cm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'High-density phenolic-faced plywood board used primarily as concrete formwork shuttering. The smooth resin-impregnated surface produces a clean concrete finish and allows multiple reuses. Resistant to moisture, chemicals, and abrasion — a cost-effective and reliable choice for slab, column, and wall formwork.',
    image: 'https://readdy.ai/api/search-image?query=phenolic%20board%20plywood%20formwork%20shuttering%20brown%20resin%20surface%20construction%20close%20up%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20building%20material&width=600&height=600&seq=str-phenolic-001&orientation=squarish'
  },
  {
    id: 118,
    name: 'Fibre Cement Board',
    category: 'structural',
    subcategory: 'Boards & Decking',
    price: 0,
    unit: 'per sheet',
    dimensions: '244cm x 122cm',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Durable fibre cement board for interior and exterior wall cladding, ceilings, and partitions. Fire-resistant, moisture-proof, and termite-resistant. The smooth surface accepts paint, tiles, and other finishes with ease — a versatile and long-lasting alternative to traditional gypsum and plywood boards.',
    image: 'https://readdy.ai/api/search-image?query=fibre%20cement%20board%20flat%20smooth%20grey%20surface%20construction%20cladding%20close%20up%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20premium%20building%20material&width=600&height=600&seq=str-fibrecement-001&orientation=squarish'
  },
  {
    id: 119,
    name: 'Steel Deck',
    category: 'structural',
    subcategory: 'Boards & Decking',
    price: 0,
    unit: 'per sqm',
    dimensions: 'Standard sheet',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Corrugated steel deck panel used as a permanent formwork and structural component for composite concrete floor slabs. The profiled steel sheet acts as both the working platform during construction and the tensile reinforcement in the finished slab. Galvanized finish ensures long-term corrosion resistance.',
    image: 'https://readdy.ai/api/search-image?query=steel%20deck%20corrugated%20metal%20floor%20decking%20composite%20slab%20construction%20close%20up%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20industrial%20building%20material&width=600&height=600&seq=str-steeldeck-001&orientation=squarish'
  },
  // Structural — Scaffolding
  {
    id: 120,
    name: 'Scaffolding Steel Ladder (6-Steps)',
    category: 'structural',
    subcategory: 'Scaffolding',
    price: 0,
    unit: 'per piece',
    dimensions: '6-step',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Heavy-duty 6-step galvanized steel scaffolding ladder designed for safe access between scaffold levels. The non-slip rungs and robust steel frame provide a secure climbing surface for workers on construction sites. Compatible with standard H-frame scaffolding systems. Hot-dip galvanized finish ensures durability in outdoor environments.',
    image: 'https://readdy.ai/api/search-image?query=scaffolding%20steel%20ladder%206%20steps%20galvanized%20construction%20site%20access%20close%20up%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20industrial%20building%20material&width=600&height=600&seq=str-ladder-001&orientation=squarish'
  },
  // Structural — Gabion & Accessories
  {
    id: 121,
    name: 'Gabion',
    category: 'structural',
    subcategory: 'Gabion & Accessories',
    price: 0,
    unit: 'per unit',
    dimensions: 'Standard',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Heavy-duty galvanized wire mesh gabion basket used for retaining walls, erosion control, and landscaping. The double-twisted hexagonal wire mesh is filled with stones or rocks to create a flexible, permeable, and durable structural element. Ideal for riverbank protection, slope stabilization, and decorative garden walls.',
    image: 'https://readdy.ai/api/search-image?query=gabion%20basket%20galvanized%20wire%20mesh%20stone%20filled%20retaining%20wall%20construction%20close%20up%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20structural%20material&width=600&height=600&seq=str-gabion-001&orientation=squarish'
  },
  {
    id: 122,
    name: 'Wall Angle',
    category: 'structural',
    subcategory: 'Gabion & Accessories',
    price: 0,
    unit: 'per piece',
    dimensions: 'Standard length',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Galvanized steel wall angle used as the perimeter trim and support for suspended ceiling grid systems. The L-shaped profile is fixed to walls at the desired ceiling height to provide a level starting point for the main tee and cross tee grid. Lightweight, easy to cut, and corrosion-resistant.',
    image: 'https://readdy.ai/api/search-image?query=wall%20angle%20galvanized%20steel%20L-shaped%20ceiling%20trim%20framing%20construction%20close%20up%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20building%20material&width=600&height=600&seq=str-wallangle-001&orientation=squarish'
  },
  {
    id: 123,
    name: 'G.I. Tire Wire',
    category: 'structural',
    subcategory: 'Gabion & Accessories',
    price: 0,
    unit: 'per roll',
    dimensions: 'Standard roll',
    pricePerPiece: 0,
    pricePerUnit: 0,
    pricePerSqm: null,
    description: 'Galvanized iron (G.I.) tie wire used for binding rebar, securing formwork, and general construction tying applications. The annealed galvanized wire is soft and flexible for easy hand-twisting, yet strong enough to hold structural elements firmly in place. Available in standard rolls for convenient use on site.',
    image: 'https://readdy.ai/api/search-image?query=GI%20tie%20wire%20galvanized%20iron%20wire%20roll%20construction%20binding%20rebar%20close%20up%20product%20shot%20on%20dark%20background%20minimalist%20studio%20photography%20building%20material&width=600&height=600&seq=str-tirewire-001&orientation=squarish'
  }
];
